import { useState } from "react";

import "./AdminSidebar.css";

const AGENT_ID  = "agent_7201kb4qh5ejexj93jey4mywph3j";
function AdminSidebar({ isOpen, onToggle, user }) {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [isGenerating, setIsGenerating] = useState(false);
  const [error, setError] = useState("");

  const handleGenerateReport = async () => {
    setError("");

    if (!fromDate || !toDate) {
      setError("Please select both From and To dates.");
      return;
    }

    setIsGenerating(true);
    try {
      const qs = new URLSearchParams({
        agent_id: AGENT_ID,
        from: fromDate,
        to: toDate,
      });

      const resp = await fetch(`/api/call-data/gen_report?${qs.toString()}`, {
        method: "GET",
      });

      if (!resp.ok) {
        let msg = `Report generation failed (${resp.status})`;
        try {
          const j = await resp.json();
          msg = j?.error ? String(j.error) : msg;
        } catch {}
        throw new Error(msg);
      }

      const blob = await resp.blob();

      const contentDisposition = resp.headers.get("content-disposition") || "";
      const match = /filename="([^"]+)"/i.exec(contentDisposition);
      const filename = match?.[1] || `sofia_report_${fromDate}_to_${toDate}.xlsx`;

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      setError(e?.message || "Failed to generate report.");
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <aside className={`admin-sidebar ${isOpen ? "open" : "collapsed"}`}>
      <button className="admin-toggle-btn" onClick={onToggle}>
        {isOpen ? "⟨" : "⟩"}
      </button>

      {isOpen && (
        <div className="admin-content">
          <p>Hello, {user?.username || "Guest"}</p>
          <h2>Reporting</h2>
          <p>Select the time range for which to generate the report:</p>

          <div className="date-picker-container">
            <div className="date-picker">
              <label>From:</label>
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                disabled={isGenerating}
              />
            </div>

            <div className="date-picker">
              <label>To:</label>
              <input
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                disabled={isGenerating}
              />
            </div>
          </div>

          {error && (
            <div style={{ marginTop: 10, color: "rgba(252,165,165,0.95)", fontSize: 14 }}>
              {error}
            </div>
          )}

          <button
            className="generate-report-btn"
            onClick={handleGenerateReport}
            disabled={isGenerating}
            title={!fromDate || !toDate ? "Select From and To dates" : ""}
          >
            {isGenerating ? "⏳ Generating..." : "📊 Generate Report"}
          </button>
        </div>
      )}
    </aside>
  );
}

export default AdminSidebar;
